import React, { useState, useEffect, useRef } from "react";
import * as S from "./styles";
import { Link } from "react-router-dom";
import * as API from "../../api";
import {
  DELAY_BUSCADOR_ZONAS,
  ZONAS_POR_PAGINA,
  TITULOS_COLUMNAS_ZONAS,
} from "../../constants";
import { Loading } from "../../components/Loading";
import { FilterRow } from "../../components/FilterRow";
import { Sort } from "../../components/Sort";
import { Button } from "../../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { usePermissions } from "../../context/PermissionsContext";

export const Zonas = () => {
  const [loading, setLoading] = useState(true);
  const { permissions } = usePermissions();
  const [loadingCount, setLoadingCount] = useState(true);
  const [zonas, setZonas] = useState([]);
  const [pages, setPages] = useState(1);
  const [countZonas, setCountZonas] = useState(0);
  const [allShowed, setAllShowed] = useState(false);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [mainFilter, setMainFilter] = useState("todos-las-zonas");
  const [openedFilter, setOpenedFilter] = useState(false);
  const [selectableFilters, setSelectableFilters] = useState([]);
  const [filters, setFilters] = useState([{ FilterId: "", FilterValue: "" }]);
  const [sortActive, setSortActive] = useState({});
  const delayTimer = useRef();
  useEffect(() => {
    getCountZonas();
    getZonas();
    API.getSearchFilter("Zona")
      .then((res) => {
        initializationFilter(res);
        setSelectableFilters(res);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    triggerSearch && handleFiltersChange();
  }, [triggerSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  const initializationFilter = (selectableFilters) => {
    const ZonesFilterId = selectableFilters.find(
      (filter) => filter.FilterName === "Nombre"
    )?.FilterId;
    const filtros = [{ FilterId: ZonesFilterId }];
    setFilters(filtros);
  };

  const pagination = (page) => {
    return { Page: page, PageSize: ZONAS_POR_PAGINA };
  };

  const getValidActiveFilters = () => {
    const activeFilters =
      mainFilter === "todos-las-zonas" ? [filters[0]] : filters;
    const validFilters = activeFilters.filter(
      (filter) => filter.FilterId && filter.FilterValue
    );
    return validFilters;
  };

  const getCountZonas = () => {
    setLoadingCount(true);
    let data = {};
    const validActiveFilters = getValidActiveFilters();
    if (validActiveFilters.length) data.Filters = validActiveFilters;

    API.getCountZones(data)
      .then((res) => {
        setCountZonas(res?.count);
        setLoadingCount(false);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  };

  const getZonas = (page = 1) => {
    setLoading(true);
    let data = {};
    data.Pagination = pagination(page);
    const validActiveFilters = getValidActiveFilters();
    if (validActiveFilters.length) data.Filters = validActiveFilters;
    data.Sort = sortActive;

    API.getZones(data)
      .then((res) => {
        if (res) {
          if (page === 1 && res.length === 0) setZonas([]);
          if (res.length > 0) {
            if (page === 1) setZonas(res);
            else setZonas([...zonas, ...res]);
          }
          if (res.length < ZONAS_POR_PAGINA) {
            setAllShowed(true);
          }
          setPages(page);
        }
        setLoading(false);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  };

  const handleFiltersChange = () => {
    API.sourceGetCountZones.cancel();
    API.sourceGetZones.cancel();
    clearTimeout(delayTimer.current);
    delayTimer.current = setTimeout(() => {
      setAllShowed(false);
      getCountZonas();
      getZonas();
    }, DELAY_BUSCADOR_ZONAS);
    setTriggerSearch(false);
  };

  const showMore = () => getZonas(pages + 1);

  const showedZonas = allShowed ? countZonas : pages * ZONAS_POR_PAGINA;
  const totalZonas = countZonas;

  const changeMainFilter = (e) => {
    const value = e.target.value;
    if (value === "todas-las-zonas") setOpenedFilter(false);
    if (value === "filtros") {
      if (filters.length === 1) addFilter();
      setOpenedFilter(true);
    }
    setMainFilter(value);

    const totalValidFilters = filters.filter(
      (filter) => filter.FilterId && filter.FilterValue
    ).length;
    const defaultsFilter = [filters[0]];
    const defaultsValidFilters = defaultsFilter.filter(
      (filter) => filter.FilterId && filter.FilterValue
    ).length;
    if (totalValidFilters !== defaultsValidFilters) setTriggerSearch(true);
  };

  const addFilter = () => {
    const filtros = [...filters];
    filtros.push({ FilterId: "", FilterValue: "" });
    setFilters(filtros);
  };

  const removeFilter = (id) => {
    const filtros = [...filters];
    if (filters.length === 2) {
      changeFieldFilter(1, "");
      setFilters(filtros);
    }
    if (filters.length > 2) {
      filtros.splice(id, 1);
      setFilters(filtros);
      if (filters[id].FilterValue !== "") setTriggerSearch(true);
    }
  };

  const changeFieldFilter = (id, value) => {
    const filtros = [...filters];
    filtros[id].FilterId = value;
    setFilters(filtros);
    if (filtros[id].FilterValue !== "") changeTextFilter(id, "");
  };

  const changeTextFilter = (id, value) => {
    const filtros = [...filters];
    filtros[id].FilterValue = value;
    setFilters(filtros);
    setTriggerSearch(true);
  };

  const sort = (field, value) => {
    setSortActive({
      FieldId: field,
      Order: value,
    });
    setTriggerSearch(true);
  };

  const deleteZona = (idZone) => {
    API.deleteZone(idZone)
      .then(() => {
        getZonas();
        toast.success("Zona Eliminada");
      })
      .catch((error) => {
        API.DEVELOP && console.log(error);
        toast.error("Error al Eliminar Zona");
      });
  };

  return (
    <S.Container>
      <Loading hidden={!loading} />
      <S.TitleBar>
        Zonas (
        {loading || loadingCount
          ? `... de ...`
          : `${showedZonas} de ${totalZonas}`}
        )
        {permissions.Zonas?.edit === 1 && (
          <S.ButtonsContainer>
            <Link to={"/Zonas/create"}>
              <Button label="Crear" disabled={loading} />
            </Link>
          </S.ButtonsContainer>
        )}
      </S.TitleBar>
      <S.SearchBar>
        <S.SelectSearchBar onChange={changeMainFilter} value={mainFilter}>
          <option value="todas-los-zonas">Todos las Zonas</option>
          <option value="filtros">Filtros</option>
        </S.SelectSearchBar>
        {mainFilter === "filtros" && (
          <S.ButtonSearchBar onClick={() => setOpenedFilter(!openedFilter)}>
            Filtros 👁
          </S.ButtonSearchBar>
        )}
        <S.InputSearchBar
          id="searchField"
          placeholder="Buscar por Nombre..."
          value={filters[0].FilterValue || ""}
          onChange={(e) => changeTextFilter(0, e.target.value)}
        />
      </S.SearchBar>
      <S.FilterBars hidden={!openedFilter}>
        {filters.map(
          (filter, index) =>
            index > 0 && (
              <FilterRow
                key={index}
                id={index}
                filter={filter}
                selectableFilters={selectableFilters}
                addFilter={addFilter}
                removeFilter={removeFilter}
                changeFieldFilter={changeFieldFilter}
                changeTextFilter={changeTextFilter}
              />
            )
        )}
      </S.FilterBars>
      <S.Table>
        <thead>
          <tr>
            {TITULOS_COLUMNAS_ZONAS.map((titulo) => (
              <S.TdThead
                key={titulo.key}
                className={titulo.key === sortActive.FieldId ? "active" : null}
              >
                <S.HeaderColumn>
                  <span>{titulo.label}</span>
                  {titulo.sortable && (
                    <Sort
                      field={titulo.key}
                      sortActive={sortActive}
                      onClick={(value) => sort(titulo.key, value)}
                    />
                  )}
                </S.HeaderColumn>
              </S.TdThead>
            ))}
          </tr>
        </thead>
        <tbody>
          {zonas.length > 0 &&
            zonas.map((zona) => (
              <tr key={zona.Id}>
                <td title={zona.Name}>
                  <Link to={"/Zonas/" + zona.Id}>{zona.Name}</Link>
                </td>
                <td title={zona.Description}>{zona.Description}</td>
                <td id="delete" title={"Eliminar"}>
                  <button onClick={() => deleteZona(zona.Id)}>
                    <FontAwesomeIcon icon={faTrashAlt} size="lg" />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </S.Table>
      <S.Pagination>
        <S.More onClick={showMore} disabled={loading || allShowed}>
          {allShowed ? "No hay más zonas" : "Más zonas..."}
        </S.More>
      </S.Pagination>
    </S.Container>
  );
};
